import {css} from 'styled-components';

export const noPrint = css`
  @media print {
    display: none!important;
  }
`;
